import React from 'react';
import MultiSelectWrapper from './MultiSelectWrapper';
import '../../index.scss';

const Filters = ({filtersArrConfig, setValue}) => {

    return (
        <div className="app-container">
            {/* test for filter in cms-test */}
            <h1 style={{display: "none"}}>test for filter in cms</h1>
            {filtersArrConfig.map((filter, index) => (
                <div className={`select-container`} key={filter.placeholder}>
                    <MultiSelectWrapper
                        options={filter.options ? filter.options : null}
                        isSearchable={filter.isSearchable}
                        isRtl={filter.isRtl}
                        isMulti={filter.isMulti}
                        placeholder={filter.placeholder}
                        placeholderText={filter.placeholderText}
                        setValue={setValue}
                    />
                </div>
            ))}
        </div>
    );
};

export default Filters;
